<template>
    <div name="media-soldoc" class="media-soldoc">
        <div class="media-inner">
            <div class="section-header">
                <strong class="title">미디어에 소개된 솔닥</strong>
            </div>

            <div class="carousel-container">
                <div class="slider-wrapper" :style="transformStyle">
                    <div
                        class="slide-card"
                        v-for="card in cards"
                        :key="card.id"
                    >
                        <div class="card-inner">
                            <div class="card-img">
                                <img :src="card.images" :alt="card.alt" />
                            </div>
                            <div class="cont-area">
                                <span
                                    class="card-category"
                                    v-html="card.category"
                                >
                                </span>
                                <strong
                                    class="card-tit"
                                    v-html="card.cardTit"
                                ></strong>

                                <span class="source">{{ card.source }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="custom-arrows">
                    <button
                        type="button"
                        class="arrow-prev"
                        @click="goToPrevSlide"
                    >
                        <span class="ico ico-left">이전</span>
                    </button>
                    <button
                        type="button"
                        class="arrow-next"
                        @click="goToNextSlide"
                    >
                        <span class="ico ico-right">다음</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "media-soldoc",
    components: {},
    data() {
        return {
            originalCards: [
                {
                    id: 0,
                    images: require("../../assets/partners_pc/img_media01.png"),
                    alt: "2023 4차 산업혁명 파워코리아 보건복지부 장관상 수상",
                    category: "AWARD",
                    cardTit:
                        "2023 4차 산업혁명 파워코리아<br>보건복지부 장관상 수상",
                    source: "한국경제 | 2023.07.17",
                },
                {
                    id: 1,
                    images: require("../../assets/partners_pc/img_media02.png"),
                    alt: "NH농협은행, 디지털 헬스케어 전문기업 솔닥과 업무협약",
                    category: "PARTNERSHIP",
                    cardTit:
                        "NH농협은행, 디지털 헬스케어<br> 전문기업 솔닥과 업무협약",
                    source: "아시아경제 | 2023.11.22",
                },
                {
                    id: 2,
                    images: require("../../assets/partners_pc/img_media03.png"),
                    alt: "대구 비대면진료 시범운영 관련 MBC 뉴스 보도",
                    category: "NEWS",
                    cardTit: "대구 비대면진료 시범운영 관련<br>MBC 뉴스 보도",
                    source: "대구MBC | 2023.11.01",
                },
                {
                    id: 3,
                    images: require("../../assets/partners_pc/img_media04.png"),
                    alt: "솔닥, 지자체 최초 비대면진료 사업 호응 얻으며 순항",
                    category: "ARTICLE",
                    cardTit:
                        "솔닥, 지자체 최초 비대면진료<br>사업 호응 얻으며 순항",
                    source: "한국경제 | 2023.10.26",
                },
                {
                    id: 4,
                    images: require("../../assets/partners_pc/img_media05.png"),
                    alt: "솔닥, 누적 100억원 투자로 디지털 인프라 확장",
                    category: "INVESTMENT",
                    cardTit: "솔닥, 누적 100억원 투자로<br>디지털 인프라 확장",
                    source: "마이데일리 | 2023.10.05",
                },
                {
                    id: 5,
                    images: require("../../assets/partners_pc/img_media06.png"),
                    alt: "솔닥, 대구시 남구청과 비대면진료 인프라 구축 협약",
                    category: "PARTNERSHIP",
                    cardTit:
                        "솔닥, 대구시 남구청과<br>비대면진료 인프라 구축 협약",
                    source: "조선BIZ | 2023.09.18",
                },
                {
                    id: 6,
                    images: require("../../assets/partners_pc/img_media07.png"),
                    alt:
                        "솔닥, 시니어 라이프 토털 솔루션 업체 ‘대교뉴이프’와 업무협약",
                    category: "PARTNERSHIP",
                    cardTit:
                        "솔닥, 시니어 라이프 토털 솔루션<br>업체 ‘대교뉴이프’와 업무협약",
                    source: "스포츠월드 | 2023.08.31",
                },
                {
                    id: 7,
                    images: require("../../assets/partners_pc/img_media08.png"),
                    alt:
                        "솔닥&케어링, 노년층 환자 대상비대면진료 제공 업무협약 체결",
                    category: "PARTNERSHIP",
                    cardTit:
                        "솔닥&케어링, 노년층 환자 대상<br>비대면진료 제공 업무협약 체결",
                    source: "아시아경제 | 2023.05.03",
                },
            ],

            // isPrevButtonVisible: false,
            // isNextButtonVisible: true,

            order: 1,
            currentIndex: 1,
            currentTranslateX: 0,
            slideWidth: 416,
        };
    },
    mounted() {
        this.setInitialPosition();
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".media-inner").offset().top;
            var aniTit = $(".media-inner .title");
            var aniItem = $(".media-inner .carousel-container");

            if (height <= innerTop - 1500) {
                $(aniTit).css("display", `none`);
                $(aniItem).css("display", `none`);
            } else if (height > innerTop - 800 && height < innerTop + 1500) {
                $(aniTit).css("display", `block`);
                $(aniItem).css("display", `block`);
            } else if (height > innerTop + 1800) {
                $(aniTit).css("display", `none`);
                $(aniItem).css("display", `none`);
            }
        });
    },
    computed: {
        cards() {
            // 복제할 카드 수
            const numberOfCopies = 3;

            // 앞쪽 복제 카드 생성
            let frontDuplicatedCards = [];
            for (let i = 0; i < numberOfCopies; i++) {
                this.originalCards.forEach((card, index) => {
                    frontDuplicatedCards.push({
                        ...card,
                        id: `front-copy-${i}-${index}`, // 고유한 ID 할당
                    });
                });
            }

            // 뒤쪽 복제 카드 생성
            let backDuplicatedCards = [];
            for (let i = 0; i < numberOfCopies; i++) {
                this.originalCards.forEach((card, index) => {
                    backDuplicatedCards.push({
                        ...card,
                        id: `back-copy-${i}-${index}`, // 고유한 ID 할당
                    });
                });
            }

            // 전체 배열을 구성
            return [
                ...frontDuplicatedCards, // 앞쪽 복제
                ...this.originalCards, // 원본 카드
                ...backDuplicatedCards, // 뒤쪽 복제
            ];
        },
        transformStyle() {
            return {
                transform: `translateX(-${this.currentTranslateX}px)`,
                transition: "transform 0.5s ease-in-out",
            };
        },
    },
    methods: {
        setInitialPosition() {
            // 초기 위치를 원본 카드 배열의 첫 번째 카드로 설정
            this.currentTranslateX =
                this.slideWidth * (1 + this.originalCards.length);
            this.currentIndex = 1 + this.originalCards.length;
        },
        goToPrevSlide() {
            if (this.currentIndex === 1) {
                // 맨 앞에 도달했을 때, 맨 뒤로 이동
                this.currentIndex =
                    this.cards.length - this.originalCards.length - 1;
                this.currentTranslateX = this.slideWidth * this.currentIndex;
            } else {
                this.currentIndex--;
                this.currentTranslateX -= this.slideWidth;
            }
            this.isPrevButtonVisible = true;
        },
        goToNextSlide() {
            if (
                this.currentIndex ===
                this.cards.length - this.originalCards.length - 1
            ) {
                // 맨 뒤에 도달했을 때, 맨 앞으로 이동
                this.currentIndex = 1;
                this.currentTranslateX = this.slideWidth;
            } else {
                this.currentIndex++;
                this.currentTranslateX += this.slideWidth;
            }
            this.isPrevButtonVisible = true;
        },
    },
};
</script>

<style scoped>
.media-soldoc {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 967px;
    background: #fff;
}
.media-soldoc .media-inner {
    position: relative;
    width: 100%;
    max-width: 1287px;
    height: 100%;
    margin: 0 auto;
    padding: 150px 20px;
    z-index: 1;
    overflow: visible;
}
.media-inner .section-header {
    width: 100%;
    text-align: center;
}
.media-inner .title {
    display: none;
    font-size: 46px;
    font-weight: 600;
    line-height: 60px;
    text-align: center;
    color: #1a1a1a;
    animation: fadeInUp2 2s;
}
.media-inner .carousel-container {
    position: relative;
    width: 100%;
    /* width: 1200px; */
    height: 526px;
    /* margin: 80px auto 0; */
    margin-top: 80px;
    overflow: visible;
    animation: fadeInUp2 2s;
}
.media-inner .carousel-container .slider-wrapper {
    display: flex;
    flex-direction: row;
    overflow: visible;
}
.media-inner .slide-card {
    flex: 0 0 auto;
    display: inline-block;
    width: 416px !important;
    height: 526px;
    padding: 0 15px;
}
/* .media-inner .slide-card:first-child {
    margin-left: -207px;
} */
.media-inner .slide-card .card-img {
    width: 100%;
    height: 312.406px;
    overflow: hidden;
}
.media-inner .slide-card .card-img img {
    width: 100%;
}
.custom-arrows {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
}
.media-inner .card-inner {
    width: 100%;
    height: 526px;

    border-radius: 16px;
    border: 1px solid #ccc;
    background: #fff;
    overflow: hidden;
}
.media-inner .cont-area {
    padding: 25px 28px;
}
.media-inner .card-category {
    display: block;
    font-size: 14px;
    font-weight: 600;
    line-height: 32px;
    color: #008def;
}
.media-inner .card-tit {
    font-size: 26px;
    font-weight: 600;
    line-height: 38px;
    color: #1a1a1a;
}
.media-inner .source {
    display: block;
    margin-top: 18px;
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
    color: #999;
}

.arrow-prev,
.arrow-next {
    position: absolute;
    width: 48px;
    height: 48px;
    text-indent: -9999px;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    transform: translateY(-50%);
    z-index: 10;
}
.arrow-prev {
    left: 0;
    background-image: url(../../assets/partners_pc/ico_chevron_left.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 28px auto;
}
.arrow-next {
    right: 0;
    background-image: url(../../assets/partners_pc/ico_chevron_right.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 28px auto;
}

@keyframes fadeInUp2 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pc_partners/MediaSoldoc.vue